<div class="checkout-container">
  <!-- Header -->
  <div class="checkout-header">
    <button mat-button class="back-button" (click)="backToCart()">
      <mat-icon>arrow_back</mat-icon>
      Back to cart
    </button>
    <h1>Checkout</h1>
  </div>

  <div class="checkout-content">
    <!-- Checkout Form -->
    <div class="checkout-form-container">
      <mat-card>
        <mat-card-header>
          <mat-card-title>Shipping Information</mat-card-title>
        </mat-card-header>

        <mat-card-content>
          <form [formGroup]="checkoutFormGroup" class="checkout-form">
            <!-- Personal Information -->
            <div class="form-section">
              <h3>Personal Information</h3>
              <div class="form-row">
                <mat-form-field appearance="outline">
                  <mat-label>Full Name</mat-label>
                  <input matInput formControlName="name" required />
                  <mat-error
                    *ngIf="checkoutForm['name'].invalid && isSubmitted"
                  >
                    Name is required
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Email Address</mat-label>
                  <input
                    matInput
                    type="email"
                    formControlName="email"
                    required
                  />
                  <mat-error
                    *ngIf="checkoutForm['email'].invalid && isSubmitted"
                  >
                    <span *ngIf="checkoutForm['email'].errors?.['required']"
                      >Email is required</span
                    >
                    <span *ngIf="checkoutForm['email'].errors?.['email']"
                      >Email is invalid</span
                    >
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Phone Number</mat-label>
                  <input
                    matInput
                    type="tel"
                    formControlName="phone"
                    placeholder="(999) 999-9999"
                  />
                </mat-form-field>
              </div>
            </div>

            <!-- Shipping Address -->
            <div class="form-section">
              <h3>Shipping Address</h3>
              <div class="form-row">
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>Street Address</mat-label>
                  <input matInput formControlName="street" required />
                  <mat-error
                    *ngIf="checkoutForm['street'].invalid && isSubmitted"
                  >
                    Street address is required
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="form-row">
                <mat-form-field appearance="outline">
                  <mat-label>Apartment (Optional)</mat-label>
                  <input matInput formControlName="apartment" />
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Zip Code</mat-label>
                  <input matInput formControlName="zip" required />
                  <mat-error *ngIf="checkoutForm['zip'].invalid && isSubmitted">
                    Zip code is required
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="form-row">
                <mat-form-field appearance="outline">
                  <mat-label>City</mat-label>
                  <input matInput formControlName="city" required />
                  <mat-error
                    *ngIf="checkoutForm['city'].invalid && isSubmitted"
                  >
                    City is required
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Country</mat-label>
                  <mat-select formControlName="country" required>
                    <mat-option value="" disabled>Select a Country</mat-option>
                    <mat-option
                      *ngFor="let country of countries"
                      [value]="country.id"
                    >
                      {{ country.name }}
                    </mat-option>
                  </mat-select>
                  <mat-error
                    *ngIf="checkoutForm['country'].invalid && isSubmitted"
                  >
                    Country is required
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </form>
        </mat-card-content>
      </mat-card>
    </div>

    <!-- Order Summary -->
    <div class="order-summary-container">
      <zodi-order-summary></zodi-order-summary>

      <mat-card class="place-order-card">
        <mat-card-content>
          <button
            mat-raised-button
            color="primary"
            class="place-order-button"
            (click)="placeOrder()"
            [disabled]="checkoutFormGroup.invalid"
          >
            <mat-icon>payment</mat-icon>
            Place Order
          </button>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
